// extracted by mini-css-extract-plugin
module.exports = {"hiddenFile":"ImportProductsButton_hiddenFile__3pZvk","btn":"ImportProductsButton_btn__WJJbl"};